(function () {
  function initGalleryPagination(root) {
    const slides = root.querySelector('[data-product-media-list]');
    const bullets = root.querySelectorAll('[data-product-gallery-pagination-bullet]');

    if (!slides || bullets.length <= 1) return;

    const slideElements = slides.querySelectorAll('[data-slide]');
    if (!slideElements.length) return;

    let ticking = false;

    function getActiveIndex() {
      const slideWidth = slideElements[0].offsetWidth;
      if (!slideWidth) return 0;

      return Math.round(slides.scrollLeft / slideWidth);
    }

    function setActiveIndex(index) {
      bullets.forEach((bullet, bulletIndex) => {
        bullet.classList.toggle('is-active', bulletIndex === index);
      });
    }

    function onScroll() {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        setActiveIndex(getActiveIndex());
        ticking = false;
      });
    }

    slides.addEventListener('scroll', onScroll, { passive: true });

    bullets.forEach((bullet) => {
      bullet.addEventListener('click', () => {
        const index = Number(bullet.dataset.index || 0);
        const target = slideElements[index];

        if (!target) return;

        slides.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth',
        });

        setActiveIndex(index);
      });
    });

    setActiveIndex(getActiveIndex());
  }

  function init() {
    document.querySelectorAll('product-images[data-product-gallery-pagination]').forEach(initGalleryPagination);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  const FIT_GUIDE_ID = 'fitGuide';

  function getFitGuideAccordion() {
    return document.getElementById(FIT_GUIDE_ID);
  }

  function getStickyHeaderOffset() {
    if (!document.querySelector('[data-header-sticky]')) return 0;

    return document.querySelector('[data-header-height]')?.offsetHeight || 0;
  }

  function getScrollTarget(accordion) {
    return accordion.querySelector('[data-collapsible-trigger]') || accordion;
  }

  function isComfortablyVisible(element) {
    const headerOffset = getStickyHeaderOffset();
    const rect = element.getBoundingClientRect();
    const topLimit = headerOffset + 8;
    const bottomLimit = window.innerHeight - 8;

    if (rect.top >= topLimit && rect.bottom <= bottomLimit) {
      return true;
    }

    const stickyForm = element.closest('.form__wrapper.is-sticky');

    if (stickyForm) {
      const formRect = stickyForm.getBoundingClientRect();

      return rect.top >= formRect.top && rect.bottom <= formRect.bottom;
    }

    return false;
  }

  function scrollToFitGuide(accordion) {
    const scrollTarget = getScrollTarget(accordion);

    if (isComfortablyVisible(scrollTarget)) return;

    const elementTop = scrollTarget.getBoundingClientRect().top;

    if (window.theme?.scrollTo) {
      window.theme.scrollTo(elementTop);
      return;
    }

    window.scrollTo({
      top: elementTop + window.scrollY - getStickyHeaderOffset(),
      left: 0,
      behavior: 'smooth',
    });
  }

  function openFitGuideAccordion() {
    const accordion = getFitGuideAccordion();
    if (!accordion) return false;

    const collapsibleRoot = accordion.closest('collapsible-elements');

    if (collapsibleRoot && typeof collapsibleRoot.open === 'function') {
      collapsibleRoot.open(accordion);
    } else {
      accordion.setAttribute('open', 'true');

      const body = accordion.querySelector('[data-collapsible-body]');
      const content = accordion.querySelector('[data-collapsible-content]');

      if (body && content) {
        body.style.height = `${content.offsetHeight}px`;
      }
    }

    requestAnimationFrame(() => {
      scrollToFitGuide(accordion);
    });

    return true;
  }

  function handleHash() {
    const hash = window.location.hash.replace('#', '');
    if (hash !== FIT_GUIDE_ID) return;

    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }

    openFitGuideAccordion();
  }

  function handleClick(event) {
    const link = event.target.closest(`a[href="#${FIT_GUIDE_ID}"]`);
    if (!link) return;

    event.preventDefault();

    if (window.location.hash !== `#${FIT_GUIDE_ID}`) {
      history.pushState(null, '', `#${FIT_GUIDE_ID}`);
    }

    openFitGuideAccordion();
  }

  document.addEventListener('DOMContentLoaded', handleHash);
  window.addEventListener('hashchange', handleHash);
  document.addEventListener('click', handleClick);
})();
